import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { PasswordDto, UserDto, UserPasswordDto } from '@api/users/interfaces';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProjectDto } from '@api/projects/interfaces';

@Injectable({
	providedIn: 'root'
})
export class UserRestService {

	constructor(private httpClient: HttpClient) { }

	listUsers$(): Observable<UserDto[]> {
		const url = `${environment.serverEndpoint}/api/users`;
		return this.httpClient.get<UserDto[]>(url);
	}

	async listUsers(): Promise<UserDto[]> {
		return await this.listUsers$().toPromise();
	}

	currentUser$(): Observable<UserDto> {
		const url = `${environment.serverEndpoint}/api/user`;
		return this.httpClient.get<UserDto>(url);
	}

	async currentUser(): Promise<UserDto> {
		return await this.currentUser$().toPromise();
	}

	userByUsername$(username: string): Observable<UserDto> {
		const url = `${environment.serverEndpoint}/api/users/${username}`;
		return this.httpClient.get<UserDto>(url);
	}

	async userByUsername(username: string): Promise<UserDto> {
		return this.userByUsername$(username).toPromise();
	}

	createUser$(user: UserPasswordDto): Observable<UserDto> {
		const url = `${environment.serverEndpoint}/api/users`;
		return this.httpClient.post<UserDto>(url, user);
	}

	async createUser(user: UserPasswordDto): Promise<UserDto> {
		return await this.createUser$(user).toPromise();
	}

	userPermissions$(username: string): Observable<string[]> {
		const url = `${environment.serverEndpoint}/api/users/${username}/permissions`;
		return this.httpClient.get<string[]>(url);
	}

	async userPermissions(username: string): Promise<string[]> {
		return await this.userPermissions$(username).toPromise();
	}

	updateUser$(user: UserDto): Observable<UserDto> {
		const url = `${environment.serverEndpoint}/api/users/${user.username}`;
		return this.httpClient.patch<UserDto>(url, user);
	}

	async updateUser(user: UserDto): Promise<UserDto> {
		return await this.updateUser$(user).toPromise();
	}

	updatePassword$(pw: PasswordDto, username: string): Observable<UserDto> {
		const url = `${environment.serverEndpoint}/api/users/${username}/password`;
		return this.httpClient.put<UserDto>(url, pw);
	}

	async updatePassword(pw: PasswordDto, username: string): Promise<UserDto> {
		return await this.updatePassword$(pw, username).toPromise();
	}

	deleteUser$(username: string): Observable<void> {
		const url = `${environment.serverEndpoint}/api/users/${username}`;
		return this.httpClient.delete<void>(url);
	}

	async deleteUser(username: string): Promise<void> {
		return await this.deleteUser$(username).toPromise();
	}

	getUserProjects$(username: string): Observable<ProjectDto[]> {
		const url = `${environment.serverEndpoint}/api/users/${username}/projects`;
		return this.httpClient.get<ProjectDto[]>(url);
	}

	async getUserProjects(username: string): Promise<ProjectDto[]> {
		return await this.getUserProjects$(username).toPromise();
	}
}
